import React from 'react';
import { Button, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import classNames from 'classnames';
import PhoneForward from 'mdi-react/PhoneForwardIcon';
import DocumentScan from 'mdi-react/ScanHelperIcon';
import FlagOutline from 'mdi-react/FlagOutlineIcon';
import Face from 'mdi-react/FaceIcon';
import Camera from 'mdi-react/CameraIcon';
import Weight from 'mdi-react/PencilRulerIcon';

import hystory from 'browserHistory';
import styles from './EditFlight.module.scss';

export type IconName = 'phoneForward' | 'documentScan' | 'flag' | 'face' | 'camera' | 'weight' | 'loading';

interface Variants {
  [key: string]: React.ReactNode;
}

const path = hystory.location.pathname.split('/')[1];

const VARIANTS = {
  phoneForward: <PhoneForward />,
  documentScan: <DocumentScan />,
  flag: <FlagOutline />,
  face: <Face />,
  camera: <Camera />,
  weight: <Weight />,
  loading: <Spinner animation="border" variant="secondary" size="sm" />,
} as Variants;

const BTN_TOOLTIPS = {
  phoneForward: 'Верифікувати номер',
  documentScan: 'Сканувати документ',
  flag: 'Додати до чорного списку',
  face: `${path === 'ordering' ? 'Додати' : 'Оримати'} FaceID з камери`,
  camera: 'Отримати номер транспорту з камери',
  weight: 'Оримати вагу',
  loading: "Триває з'єднання",
} as Variants;

type Props = {
  icon: IconName;
  clickHandler?: () => void;
  disabled?: boolean;
  className?: string;
  mode?: 'kiosk' | 'main';
};

const EditFlight: React.FC<Props> = ({ icon, clickHandler, mode = 'main', disabled = false, className = '' }) => (
  <OverlayTrigger
    key={icon}
    placement="top"
    overlay={disabled ? <span /> : <Tooltip id={`tooltip-${icon}`}>{BTN_TOOLTIPS[icon]}</Tooltip>}
  >
    <Button
      variant={mode === 'main' ? 'light' : 'success'}
      className={classNames('p-0 w-h-26', className, mode === 'main' ? styles.btn : styles.btn_kiosk)}
      {...(clickHandler && { onClick: clickHandler })}
      disabled={disabled}
    >
      {VARIANTS[icon]}
    </Button>
  </OverlayTrigger>
);

export default EditFlight;
